export default {
	types: [
		{
			value: 'enc',
			text: 'Encaissement faisant suite à l\'enregistrement d\'un chèque'
		},
		{
			value: 'rpr',
			text: 'Reprise sur flux'
		},
		{
			value: 'pcl',
			text: 'Paiement en ligne'
		},
		{
			value: 'cmp',
			text: 'Complément de solde'
		},
		{
			value: 'pai',
			text: 'Ordre de paiement'
		}
	]
};